<template>
    <b-container fluid>
        <b-row>
            <b-col lg="12" sm="12">
                <iq-card>
                    <template v-slot:body>
                        <b-row>
                            <b-col xl="12" lg="12" sm="12">
                                <b-overlay :show="loading" rounded="sm">
                                    <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                                        <b-form @submit.prevent="handleSubmit(register)" @reset.prevent="reset">
                                            <!--    training title -->
                                            <b-row>
                                                <b-col lg="6" sm="6">
                                                    <ValidationProvider name="Fiscal Year" vid="fiscal_year_id" rules="required|min_value:1">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="4"
                                                            label-for="fiscal_year_id"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{ $t('globalTrans.fiscal_year') }} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-select
                                                                plain
                                                                :disabled="formData.routines[0].date ? true : false"
                                                                v-model="formData.fiscal_year_id"
                                                                :options="fiscalYearList"
                                                                id="fiscal_year_id"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                                <template v-slot:first>
                                                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                                </template>
                                                            </b-form-select>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="6" sm="6">
                                                    <ValidationProvider name="Circular" vid="circular_id" rules="required|min_value:1">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="4"
                                                            label-for="circular_id"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{ $t('tp_management.circular_no') }} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-select
                                                                plain
                                                                :disabled="formData.routines[0].date ? true : false"
                                                                v-model="formData.circular_id"
                                                                :options="circularList"
                                                                id="circular_id"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                                <template v-slot:first>
                                                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                                </template>
                                                            </b-form-select>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="6" sm="6">
                                                    <b-spinner v-if="moduleSpinLoader && !id" class="overlay" variant="success" small label="Spinning"></b-spinner>
                                                    <ValidationProvider name="Training Title" vid="training_name_id" rules="required|min_value:1">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="4"
                                                            label-for="training_name_id"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{ $t('elearning_config.training') + ' ' + $t('elearning_config.title') }} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-select
                                                                plain
                                                                :disabled="true"
                                                                v-model="formData.training_name_id"
                                                                :options="trainingNameList"
                                                                id="training_name_id"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                                <template v-slot:first>
                                                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                                </template>
                                                            </b-form-select>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="6" sm="6">
                                                    <b-spinner v-if="moduleSpinLoader && !id" class="overlay" variant="success" small label="Spinning"></b-spinner>
                                                    <ValidationProvider name="Batch" vid="batch_id" rules="required|min_value:1">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="4"
                                                            label-for="batch_id"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{ $t('trainer_trainee.batch') }} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-select
                                                                plain
                                                                v-model="formData.batch_id"
                                                                :options="batchList"
                                                                id="batch_id"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                                <template v-slot:first>
                                                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                                </template>
                                                            </b-form-select>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                            </b-row>
                                            <hr>
                                            <!-- routine Loop Start Here -->
                                            <b-overlay :show="moduleSpinLoader">
                                                <div v-for="(routine, index) in formData.routines" :key="index">
                                                    <iq-card class="p-2">
                                                        <b-row v-if="isLoadDate">
                                                            <b-col lg="4" sm="4">
                                                             <!--   <ValidationProvider name="Date" vid="training_date_id" rules="required">
                                                                    <b-form-group
                                                                        class="row"
                                                                        label-cols-sm="2"
                                                                        label-for="training_date_id"
                                                                        slot-scope="{ valid, errors }"
                                                                    >
                                                                        <template v-slot:label>
                                                                            {{$t('globalTrans.date')}} <span class="text-danger">*</span>
                                                                        </template>
                                                                        <flat-pickr class="form-control"
                                                                            :config="{ minDate: startDate, maxDate: endDate }"
                                                                            v-model="routine.training_date"
                                                                            :placeholder="$t('globalTrans.select_date')"
                                                                            :state="errors[0] ? false : (valid ? true : null)"
                                                                        ></flat-pickr>
                                                                        <div class="invalid-feedback d-block">
                                                                            {{ errors[0] }}
                                                                        </div>
                                                                    </b-form-group>
                                                                </ValidationProvider>-->
                                                              <ValidationProvider name="Date" vid="training_date_id" rules="required|min:5">
                                                                <b-form-group
                                                                  class="row"
                                                                  label-cols-sm="4"
                                                                  label-for="training_date_id"
                                                                  slot-scope="{ valid, errors }"
                                                                >
                                                                  <template v-slot:label>
                                                                    {{$t('globalTrans.date')}} <span class="text-danger">*</span>
                                                                  </template>
                                                                  <b-form-select
                                                                    plain
                                                                    @change="Check(routine.training_date)"
                                                                    v-model="routine.training_date"
                                                                    :options="dateList"
                                                                    id="fiscal_year_id"
                                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                                  >
                                                                    <template v-slot:first>
                                                                      <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                                    </template>
                                                                  </b-form-select>
                                                                  <div class="invalid-feedback">
                                                                    {{ errors[0] }}
                                                                  </div>
                                                                </b-form-group>
                                                              </ValidationProvider>
                                                            </b-col>
                                                        </b-row>
                                                        <!-- Transport Driver Nested Loop Start Here -->
                                                        <b-table-simple  bordered>
                                                            <thead>
                                                            <tr class="bg-primary">
                                                                <th scope="col" style="width:10%">{{ $t('tp_management.start_time') }}</th>
                                                                <th scope="col" style="width:10%">{{ $t('tp_management.end_time') }}</th>
                                                                <th scope="col" style="width:20%">{{ $t('tp_management.activity_type') }}</th>
                                                                <th scope="col" style="width:20%">{{ $t('tp_management.module') }}</th>
                                                                <th scope="col" style="width:20%">{{ $t('tp_management.course') }}</th>
                                                                <th scope="col" style="width:20%">{{ $t('tp_management.trainer') }}</th>
                                                                <th scope="col" class="text-center">{{ $t('globalTrans.action') }}</th>
                                                            </tr>
                                                            </thead>
                                                            <b-tbody>
                                                                <b-tr v-for="(schedule, inx) in routine.schedules" :key="inx">
                                                                    <b-td>
                                                                        <ValidationProvider name="Start Time" vid="start_time" rules="required">
                                                                            <b-form-group
                                                                                slot-scope="{ valid, errors }"
                                                                            >
                                                                                <b-form-input
                                                                                    :id="'start_time' + index + '_' + inx"
                                                                                    type="time"
                                                                                    v-model="schedule.start_time"
                                                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                                                ></b-form-input>
                                                                                <div class="invalid-feedback">
                                                                                    {{ errors[0] }}
                                                                                </div>
                                                                            </b-form-group>
                                                                        </ValidationProvider>
                                                                    </b-td>
                                                                    <b-td>
                                                                        <ValidationProvider name="End Time" vid="end_time" rules="required">
                                                                            <b-form-group
                                                                                slot-scope="{ valid, errors }"
                                                                            >
                                                                                <b-form-input
                                                                                    :id="'end_time' + index + '_' + inx"
                                                                                    type="time"
                                                                                    v-model="schedule.end_time"
                                                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                                                ></b-form-input>
                                                                                <div class="invalid-feedback">
                                                                                    {{ errors[0] }}
                                                                                </div>
                                                                            </b-form-group>
                                                                        </ValidationProvider>
                                                                    </b-td>
                                                                    <b-td>
                                                                        <ValidationProvider name="Activity Type" vid="activity_id" rules="required|min_value:1">
                                                                            <b-form-group
                                                                                slot-scope="{ valid, errors }"
                                                                            >
                                                                                <b-form-select
                                                                                    plain
                                                                                    v-model="schedule.activity_type"
                                                                                    :options="activityTypeList"
                                                                                    :id="'activity_id' + index + '_' + inx"
                                                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                                                >
                                                                                    <template v-slot:first>
                                                                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                                                    </template>
                                                                                </b-form-select>
                                                                                <div class="invalid-feedback">
                                                                                    {{ errors[0] }}
                                                                                </div>
                                                                            </b-form-group>
                                                                        </ValidationProvider>
                                                                    </b-td>
                                                                    <b-td v-if="parseInt(schedule.activity_type) === 1">
                                                                        <ValidationProvider name="Module Name" vid="module_id" rules="required|min_value:1">
                                                                            <b-form-group
                                                                                slot-scope="{ valid, errors }"
                                                                            >
                                                                                <b-form-select
                                                                                    plain
                                                                                    v-model="schedule.module_id"
                                                                                    :options="moduleList"
                                                                                    :id="'module_id' + index + '_' + inx"
                                                                                    @change="getSyllabus(schedule.module_id, index, inx)"
                                                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                                                >
                                                                                    <template v-slot:first>
                                                                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                                                    </template>
                                                                                </b-form-select>
                                                                                <div class="invalid-feedback">
                                                                                    {{ errors[0] }}
                                                                                </div>
                                                                            </b-form-group>
                                                                        </ValidationProvider>
                                                                    </b-td>
                                                                    <b-td v-if="parseInt(schedule.activity_type) === 1">
                                                                        <ValidationProvider name="Course Name" vid="course_id" rules="required|min_value:1">
                                                                            <b-form-group
                                                                                slot-scope="{ valid, errors }"
                                                                            >
                                                                                <b-form-select
                                                                                    plain
                                                                                    v-model="schedule.course_id"
                                                                                    :options="id ? allSyllabusList : schedule.syllabusList"
                                                                                    :id="'course_id' + index + '_' + inx"
                                                                                    @change="getCourseTrainer(schedule.course_id, index, inx)"
                                                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                                                >
                                                                                    <template v-slot:first>
                                                                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                                                    </template>
                                                                                </b-form-select>
                                                                                <div class="invalid-feedback">
                                                                                    {{ errors[0] }}
                                                                                </div>
                                                                            </b-form-group>
                                                                        </ValidationProvider>
                                                                    </b-td>
                                                                    <b-td v-if="parseInt(schedule.activity_type) === 1">
                                                                        <ValidationProvider name="Trainer Name" vid="trainer_id" rules="required|min_value:1">
                                                                            <b-form-group
                                                                                slot-scope="{ valid, errors }"
                                                                            >
                                                                                <b-form-select
                                                                                    plain
                                                                                    v-model="schedule.trainer_id"
                                                                                    :options="trainerList"
                                                                                    :id="'trainer_id' + index + '_' + inx"
                                                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                                                >
                                                                                    <template v-slot:first>
                                                                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                                                    </template>
                                                                                </b-form-select>
                                                                                <div class="invalid-feedback">
                                                                                    {{ errors[0] }}
                                                                                </div>
                                                                            </b-form-group>
                                                                        </ValidationProvider>
                                                                    </b-td>
                                                                    <b-td v-if="parseInt(schedule.activity_type) === 2" colspan="3">
                                                                      <ValidationProvider name="Task Name" vid="task_id" rules="required">
                                                                        <b-form-group
                                                                          slot-scope="{ valid, errors }"
                                                                        >
                                                                          <b-form-input
                                                                            plain
                                                                            placeholder="Write event name here.."
                                                                            v-model="schedule.other_event"
                                                                            :id="'trainer_id' + index + '_' + inx"
                                                                            :state="errors[0] ? false : (valid ? true : null)"
                                                                          >
                                                                          </b-form-input>
                                                                          <div class="invalid-feedback">
                                                                            {{ errors[0] }}
                                                                          </div>
                                                                        </b-form-group>
                                                                      </ValidationProvider>
                                                                    </b-td>
                                                                    <b-td class="pl-1 pt-8 pr-0 pb-0">
                                                                        <button v-if="inx === formData.routines[index].schedules.length - 1" style="font-size: 11px"  type="button" class="btn btn-sm btn-primary" @click.prevent="addSchedule(index)">
                                                                            +
                                                                        </button>
                                                                        <b-button v-if="inx > 0" type="button" @click="removeSchedule(inx, index)" style="font-size: 11px" class="btn btn- iq-bg-danger btn-sm text-center ml-1"><i class="ri-delete-bin-line m-0"></i></b-button>
                                                                    </b-td>
                                                                </b-tr>
                                                            </b-tbody>
                                                        </b-table-simple>
                                                        <!-- Transport Driver Nested Loop End Here -->
                                                    </iq-card>
                                                    <b-row>
                                                        <b-col lg="12" sm="12" class="text-right mb-3">
                                                            <button v-if="index === formData.routines.length - 1" type="button" class="btn btn-sm iq-bg-primary" @click.prevent="addRoutine(index)">
                                                                {{ $t('ds_institute_management.add')}}
                                                            </button>
                                                            <button v-if="index > 0" type="button" class="btn btn-sm iq-bg-danger" @click="removeRoutine(index)"
                                                            >
                                                                {{ $t('ds_institute_management.delete')}}
                                                            </button>
                                                        </b-col>
                                                    </b-row>
                                                </div>
                                                <div class="row">
                                                    <div class="col-sm-3"></div>
                                                    <div class="col text-right">
                                                        <b-button type="submit" variant="primary" class="mr-1">{{ saveBtnName }}</b-button>                                                    &nbsp;
                                                        <b-button type="button" variant="danger" @click="$bvModal.hide('modal-4')">{{ $t('globalTrans.cancel') }}</b-button>
                                                    </div>
                                                </div>
                                            </b-overlay>
                                        </b-form>
                                    </ValidationObserver>
                                </b-overlay>
                            </b-col>
                        </b-row>
                    </template>
                </iq-card>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { trainingElearningServiceBaseUrl } from '@/config/api_config'
import { trainingRoutineStoreApi, trainingRoutineUpdateApi, circularDataApi, moduleDataApi } from '../../api/routes'

export default {
    name: 'FormLayout',
    props: ['id'],
    components: {
        ValidationObserver,
        ValidationProvider
    },
    created () {
        // this.getModuleList()
        if (this.id) {
            const tmp = this.getData()
          //  this.formData.fiscal_year_id = tmp.fiscal_year_id
          //  this.formData.circular_id = tmp.circular_id
          //  this.formData.training_name_id = tmp.training_name_id
          //  this.formData.batch_id = tmp.batch_id
            this.formData = tmp
            // this.getCircularData()
            this.getModuleData()
            this.isLoadDate = true
        }
    },
    mounted () {
        core.index()
    },
    data () {
        return {
            saveBtnName: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
            loading: false,
            moduleSpinLoader: false,
            isLoadDate: false,
            startDate: '',
            endDate: '',
            dateList: [],
            tmpFormData: {},
            formData: {
                fiscal_year_id: 0,
                circular_id: 0,
                training_name_id: 0,
                batch_id: 0,
                routines: [
                    {
                        training_date: 0,
                        schedules: [
                            {
                                start_time: '',
                                end_time: '',
                                activity_type: 1,
                                module_id: 0,
                                course_id: 0,
                                trainer_id: 0,
                                other_event: '',
                                syllabusList: []
                            }
                        ]
                    }
                ]
            },
            circularList: [],
            batchList: [],
            moduleList: [],
            allSyllabusList: [],
            trainerList: [],
            activityTypeList: [
                {
                    value: 1,
                    text: this.$i18n.locale === 'en' ? 'Course' : 'কোর্স'
                },
                {
                    value: 2,
                    text: this.$i18n.locale === 'en' ? 'Others Event' : 'অন্যান্য ঘটনা'
                }
            ]
        }
    },
    computed: {
        fiscalYearList: function () {
            return this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0)
        },
        trainingNameList: function () {
            const obj = this.$store.state.TrainingElearning.commonObj.trainingNameList.filter(item => item.status === 1)
            return obj.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
        }
    },
    watch: {
        'formData.fiscal_year_id': function () {
            this.circularList = this.getCircularList()
        },
        'formData.circular_id': function (newVal, oldVal) {
            if (newVal !== oldVal) {
                this.getCircularData()
            }
        },
        'formData.batch_id': function (newVal, oldVal) {
          if (newVal !== oldVal) {
            this.getModuleData()
          }
        }
    },
    methods: {
      Check (item) {
      },
        addRoutine (index) {
            this.$refs.form.validate()
            this.formData.routines.push({
                training_date: '',
                schedules: [
                    {
                        start_time: '',
                        end_time: '',
                        activity_type: 1,
                        module_id: 0,
                        course_id: 0,
                        trainer_id: 0
                    }
                ]
            })
            this.moduleNameList.forEach((element, key) => {
                if (element.value === this.formData.routines[index].training_date) {
                    // element.disabled = true
                }
            })
        },
        addSchedule (index) {
            this.formData.routines.forEach((element, key) => {
                if (key === index) {
                    element.schedules.push({
                        start_time: '',
                        end_time: '',
                        activity_type: 1,
                        module_id: 0,
                        course_id: 0,
                        trainer_id: 0
                    })
                }
            })
        },
        removeSchedule (inx, index) {
            this.formData.routines.forEach((element, key) => {
                if (key === index) {
                    element.schedules.splice(inx, 1)
                }
            })
        },
        removeRoutine (index) {
            this.formData.routines.splice(index, 1)
        },
        async register () {
            this.loading = true
            this.$store.dispatch('mutateCommonProperties', { loading: true })
            let result = null
            const loadinState = { loading: false, listReload: true }
            if (this.id) {
                result = await RestApi.putData(trainingElearningServiceBaseUrl, `${trainingRoutineUpdateApi}/${this.id}`, this.formData)
            } else {
                result = await RestApi.postData(trainingElearningServiceBaseUrl, trainingRoutineStoreApi, this.formData)
            }
            this.$store.dispatch('mutateCommonProperties', loadinState)
            if (result.success) {
                this.loading = false
                this.$toast.success({
                    title: this.$t('globalTrans.success'),
                    message: this.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save_msg'),
                    color: '#D6E09B'
                })
                this.$bvModal.hide('modal-4')
            } else {
                this.loading = false
              this.$refs.form.setErrors(result.message)
              this.$toast.error({
                title: 'Warning!',
                message: result.message,
                color: '#D6E09B'
              })
            }
        },
        getData () {
            const tmpData = this.$store.state.list.find(item => item.id === parseInt(this.id))
            return JSON.parse(JSON.stringify(tmpData))
        },
        getCircularList () {
            const obj = this.$store.state.TrainingElearning.commonObj.circularMemoList.filter(item => item.fiscal_year_id === this.formData.fiscal_year_id)
            return obj.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
        },
        async getCircularData () {
            if (this.formData.fiscal_year_id && this.formData.circular_id) {
                this.moduleSpinLoader = true
                const result = await RestApi.getData(trainingElearningServiceBaseUrl, circularDataApi, { fiscal_year_id: this.formData.fiscal_year_id, circular_id: this.formData.circular_id })
                if (result.success) {
                    this.formData.training_name_id = result.training
                    this.batchList = result.batch.map((item, index) => {
                        return Object.assign({}, { value: item.batch_d.id, text: item.batch_d.batch, text_bn: item.batch_d.batch_bn })
                    })
                    this.moduleSpinLoader = false
                }
            }
        },
        async getModuleData () {
            if (this.formData.training_name_id) {
                this.isLoadDate = true
                this.moduleSpinLoader = true
                const result = await RestApi.getData(trainingElearningServiceBaseUrl, moduleDataApi, { fiscal_year_id: this.formData.fiscal_year_id, circular_id: this.formData.circular_id, training_name_id: this.formData.training_name_id, batch_id: this.formData.batch_id })
                if (result.success) {
                    this.moduleSpinLoader = false
                    this.moduleList = result.modules.map(item => {
                        return Object.assign({ value: item.id, text: this.$i18n.locale === 'en' ? item.name : item.name_bn })
                    })
                    this.allSyllabusList = result.syllabus.map(item => {
                        return Object.assign({ value: item.id, module_id: item.module_id, text: this.$i18n.locale === 'en' ? item.name : item.name_bn })
                    })
                    this.trainerList = result.trainer.map(item => {
                        return Object.assign({ value: item.id, text: this.$i18n.locale === 'en' ? item.name : item.name_bn })
                    })
                    this.startDate = result.batchDateRange.start_date
                    this.endDate = result.batchDateRange.end_date
                  this.dateDropDownMaker(result.batchDateRange.start_date, result.batchDateRange.end_date)
                    this.moduleSpinLoader = false
                }
            }
        },
        dateDropDownMaker (start, end) {
          const dateList = []
          dateList.push({
            text: new Date(start).toISOString().slice(0, 10),
            value: new Date(start).toISOString().slice(0, 10)
          })
          var date1 = new Date(start)
          var date2 = new Date(end)
          var diff = new Date(date2.getTime() - date1.getTime())
          const dat = diff.getUTCDate() - 1
          for (var i = 1; i <= dat; i++) {
            var result = new Date(start)
            result.setDate(result.getDate() + i)
            dateList.push({
              text: new Date(result).toISOString().slice(0, 10),
              value: new Date(result).toISOString().slice(0, 10)
            })
          }
         this.dateList = dateList
        },
        getSyllabus (id, index, inx) {
            this.formData.routines[index].schedules[inx].syllabusList = this.allSyllabusList.filter(item => item.module_id === id).map((obj, key) => {
                return { value: obj.value, text: obj.text }
            })
        }
    }
}
</script>
<style scoped>
.overlay {
    position: absolute;
    left: 65%;
    z-index: 9999;
    top: 10px;
    text-align: center;
}
</style>
